import { RiDeleteBinLine } from "react-icons/ri";
import styles from "./SingleImage.module.css";
import { BiSolidShareAlt } from "react-icons/bi";
import { LuDelete, LuDownload, LuTrash } from "react-icons/lu";
import { Carousel, Col, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../../../components/modal/Modal";
import { SubmitButton, TextComponent } from "../../../../../components";
import { useEffect, useState } from "react";
import CopyLinkModal from "../../../../../components/copyLinkModal/CopyLinkModal";
import { saveAs } from "file-saver";
import { PhotosMiddleware } from "../../../../../Store/Middlewares/PhotosMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { roles } from "../../../../../config/roles";
import Storage from "../../../../../utills/AsyncStorage";
import { InspirationalGalleryMiddleware } from "../../../../../Store/Middlewares/InspirationalGalleryMiddleware";

const SingleImage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  // const MyPhotosList = useSelector((state) => state.PhotosReducer.MyPhotosList);
  const images = useLocation().state.item;
  const screenType = useLocation().state.screenType;

  const [item, setItem] = useState(images);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const role = Storage.getERole("@role");
  // useEffect(() => {
  //   getData();
  // }, []);
  // const getData = () => {
  //   let data = {
  //     category_id: item?.id,
  //     // search: undefined,
  //     // next_page_url: undefined,
  //   };
  //   dispatch(PhotosMiddleware.getMyPhotos(data));
  // };

  function downloadImage(src, name) {
    const href = `https://www.bestdayever.me/api/downloadFile?path=${src}`;
    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = `${name}`;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  }
  const filename = item?.image?.substring(item?.image.lastIndexOf("/") + 1);

  const onDeletePhoyo = (id) => {
    dispatch(
      InspirationalGalleryMiddleware.deletePhotoByID({ gallery_id: id })
    ).then(() => {
      setItem((prev) => ({
        ...prev,
        attachments: prev?.attachments?.filter?.((items) => items.id != id),
      }));
    });
  };

  console.log(item);

  return (
    <div className={styles.mainCon}>
      <div className={styles.header}>
        <TextComponent text={item?.name} textClass={styles.headTxt} />
        {(role === roles.client || role === roles.coHost) && (
          <SubmitButton
            title={"Add Images"}
            btnClass={styles.addImgBtn}
            onClick={() =>
              navigation("/events/uploadGallery", {
                state: {
                  event_id: item?.event_id,
                  screen:"single",
                  category: {
                    category_id: item?.id,
                    category_name: item?.val,
                  },
                },
              })
            }
          />
        )}
      </div>
      {/* <Row className={styles.iconRow}>
        <div
          className={styles.iconBtn}
          onClick={() => downloadImage(item?.image, `${filename}`)}
        >
          <LuDownload className={styles.icon} />
        </div>
        <div className={styles.iconBtn} onClick={() => setModalOpen(true)}>
          <BiSolidShareAlt className={styles.icon} />
        </div>
      </Row> */}
      <Carousel
        className={`${styles.Carousel} caroselOverride`}
        // autoplay
        dots={{ className: "dotsCarosel" }}
        nextArrow={<BsChevronRight size={40} color="var(--primary-color)" />}
        prevArrow={<BsChevronLeft size={40} color="var(--primary-color)" />}
        arrows
        infinite={true}
      >
        {item?.attachments?.map((item, i) => {
          if (item?.type == "video") {
            return (
              // <div key={index} className={styles.listItem}>
              //   <div className={styles.square}>
              <>
                <Row className={styles.iconRow}>
                  <div
                    className={styles.iconBtn}
                    onClick={() => downloadImage(item?.files, `${filename}`)}
                  >
                    <LuDownload className={styles.icon} />
                  </div>
                  {screenType == "myPhoto" && (
                    <div
                      className={styles.iconBtn}
                      onClick={() => onDeletePhoyo(item?.id)}
                    >
                      <LuTrash className={styles.icon} />
                    </div>
                  )}
                </Row>
                <video className={styles.imageCont} controls>
                  <source src={item?.files} />
                </video>
              </>

              //   </div>
              // </div>
            );
          } else {
            return (
              <>
                <Row className={styles.iconRow}>
                  <div
                    className={styles.iconBtn}
                    onClick={() => downloadImage(item?.files, `${filename}`)}
                  >
                    <LuDownload className={styles.icon} />
                  </div>
                  {screenType == "myPhoto" && (
                    <div
                      className={styles.iconBtn}
                      onClick={() => onDeletePhoyo(item?.id)}
                    >
                      <LuTrash className={styles.icon} />
                    </div>
                  )}
                </Row>
                <div className={styles.imageCont}>
                  <img src={item?.files} className={styles.image} />
                </div>
              </>
            );
          }

          // <div className={styles.imgDiv}>
          //   <img src={item?.files} className={styles.image} />
          // </div>
          // <IGImageDetails
          //   key={item.id}
          //   item={item}
          //   setDeleteImgModal={setDeleteImgModal}
          //   setDeleteId={setDeleteId}
          // />
        })}
      </Carousel>
      <CopyLinkModal
        isCopyModalOpen={modalOpen}
        setIsCopyModalOpen={setModalOpen}
        link={item?.files}
      />
    </div>
  );
};

export default SingleImage;
